<template>
  <div v-if="accessories.length > 0" class="accSlider-wrap">
    <div class="wrapper">
      <p class="fs-36 bold color-black mt-0">
        {{trans['accessories']}}
      </p>
      <flickity ref="flickity" :options="accessoriesOptions" class="accSlider">
        <div v-for="item in accessories" :key="item.id">
          <div class="item">
            <div class="img-wrap">
              <img :src="item['media_content'].preview" alt="" class="picture"/>
            </div>
            <div class="text-wrap">
              <p class="accSlider__text">
                {{ item['web_bike_title'] }}
              </p>
              <p class="accSlider__price">{{ price(item) }}</p>
              <a class="btn btn-outline-primary" @click.prevent="addToBag(item)">
                {{trans['buy']}}
              </a>
            </div>
          </div>
        </div>
      </flickity>
    </div>
  </div>
</template>

<script>
import Flickity from 'vue-flickity'

export default {
  name: "AccessoriesCarousel",
  props: {
    accessories: {
      required: true,
      type: Array
    },
    trans: {
      required: true
    }
  },
  components: {
    Flickity,
  },
  data() {
    return {
      accessoriesOptions: {
        prevNextButtons: false,
        cellAlign: 'left',
        contain: true,
        percentPosition: true,
        on: {
          staticClick: function (event, pointer, cellElement, cellIndex) {
            if (typeof cellIndex == 'number') {
              this.selectCell(cellIndex);
            }
          },
        }
      },
    }
  },
  methods: {
    price(item) {
      return this.$crConverter(item['prices']['price_for_eu'] / 100, 'EUR')
    },
    addToBag(item) {
      this.$store.dispatch('build/addToBasket', {
        path: this.$path,
        build: item,
        purchase_type: 'full',
        extra: [],
        custom_color: false
      }).then(result => {
        this.$store.commit('baskets/addOrUpdateItem', result.item)
      })
    }
  },
}
</script>

<style lang="scss">
@mixin moveLeft {
  margin-left: calc((100vw - 1158px) / 2);

  @media (max-width: 1300px) {
    margin-left: calc((100vw - 1020px) / 2);
  }
  @media (max-width: 1060px) {
    margin-left: 20px;
  }
}

.accSlider-wrap {
  overflow: hidden;
}

.accSlider {
  .flickity-slider > div {
    min-height: 100%;
    display: flex;
  }

  .flickity-slider {
    //@include moveLeft;
  }

  .flickity-viewport {
    overflow: visible;
  }

  .item {
    min-height: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-start;
    background: #f8f8f8;
    border-radius: 16px;
    padding: 24px;
    width: 328px;
    box-sizing: border-box;
    margin-right: 20px;

    .img-wrap {
      position: relative;
      padding-top: 100%;
      width: 100%;
      margin-bottom: 46px;

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
        z-index: 1;
        mix-blend-mode: darken;
      }
    }

    .text-wrap {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: auto;

      .accSlider__text {
        width: 100%;
        font-weight: normal;
        font-size: 17px;
        line-height: 150%;
        color: #000000;
        height: 50px;
        overflow: hidden;
        margin: 0 0 20px;
      }

      .accSlider__price {
        font-weight: bold;
        font-size: 20px;
        line-height: 21px;
        color: #000000;
        margin: 0 auto 0 0;
        padding-right: 12px;
      }

      .btn {
        width: 133px;
        cursor: pointer;
      }
    }
  }

  .flickity-page-dots {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    margin: 45px 0 0;

    .dot {
      width: 6px;
      height: 6px;
      border-radius: 100%;
      background-color: #C4C4C4;
      display: block;
      margin: 0 7px;
      border: none;
      opacity: 1;

      &:after {
        display: none;
      }

      &.is-selected {
        background-color: #c2e900;
      }
    }
  }

  @media (max-width: 991px) {
    .item {
      width: 236px;

      .img-wrap {
        margin-bottom: 32px;
      }

      .text-wrap {
        .accSlider__text {
          height: 75px;
          margin-bottom: 32px;
        }

        .accSlider__price {
          width: 100%;
          margin-bottom: 12px;
        }

        .btn {
          width: 100%;
        }
      }
    }
    .flickity-page-dots {
      margin-top: 32px;
    }
  }
  @media (max-width: 575px) {
    .item {
      width: 294px;
      padding: 16px;

      .img-wrap {
        margin-bottom: 24px;
      }

      .text-wrap {
        .accSlider__text {
          height: 52px;
          margin-bottom: 24px;
        }

        .accSlider__price {
          width: auto;
          margin: 0 auto 0 0;
        }

        .btn {
          width: 112px;
        }
      }
    }
  }
}
</style>
